import { computed, EventEmitter, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { setShowBenchmarkOption } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/show-benchmark-option/show-benchmark-option.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { getCurrentWizardStepIndex, getShowBenchmarkOption, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { ShowBenchmarkOption } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/show-benchmark-option.enum';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function SelectBenchmarkOptionModalComponent_Conditional_36_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function SelectBenchmarkOptionModalComponent_Conditional_36_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.back()); });
    i0.ɵɵtext(1, "Back");
    i0.ɵɵelementEnd();
} }
/**
 * Select Benchmark Option Modal Component
 *
 * Wizard step that lets the user choose whether the generated report should show benchmarks for
 * every module, no modules, or each module's own saved "Show Benchmark" setting.
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when the wizard should move to the previous step or next step.
 *
 */
export class SelectBenchmarkOptionModalComponent {
    constructor() {
        this.broadcastWizardStepEvent = new EventEmitter();
        this.ShowBenchmarkOption = ShowBenchmarkOption;
        this.store = inject(Store);
        this.modalState = toSignal(this.store.select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY), { requireSync: true });
        this.currentWizardStepIndex = computed(() => getCurrentWizardStepIndex(this.modalState()), ...(ngDevMode ? [{ debugName: "currentWizardStepIndex" }] : []));
        this.showBenchmarkOption = computed(() => getShowBenchmarkOption(this.modalState()), ...(ngDevMode ? [{ debugName: "showBenchmarkOption" }] : []));
        this.modalOpen = false;
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
    }
    exitModalHandler() {
        this.closeModal();
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
    selectOption(option) {
        this.store.dispatch(setShowBenchmarkOption({ showBenchmarkOption: option }));
    }
    back() {
        this.closeModal();
        this.store.dispatch(decrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
    }
    forward() {
        this.closeModal();
        this.store.dispatch(incrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
    }
}
SelectBenchmarkOptionModalComponent.ɵfac = function SelectBenchmarkOptionModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectBenchmarkOptionModalComponent)(); };
SelectBenchmarkOptionModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectBenchmarkOptionModalComponent, selectors: [["ycn-select-benchmark-option-modal"]], outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 39, vars: 5, consts: [[3, "closeModalHandler", "open"], ["header", "Show Benchmark", 3, "closeModalHandler"], [1, "modal-body"], [1, "modal-section"], [1, "custom-controls-stacked", "custom-controls-stacked-airy"], [1, "custom-control", "custom-radio", "custom-radio-rich"], ["type", "radio", "name", "benchmarkDisplay", "data-test-id", "show-benchmark-option-all", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "text-gray-30"], ["type", "radio", "name", "benchmarkDisplay", 1, "custom-control-input", 3, "change", "checked"], [1, "modal-footer"], [1, "modal-footer-info"], [1, "btn", "btn-text", 3, "click"], [1, "modal-footer-actions"], [1, "btn", "btn-secondary"], ["data-test-id", "submit-show-benchmark-option", 1, "btn", "btn-primary", 3, "click"], [1, "btn", "btn-secondary", 3, "click"]], template: function SelectBenchmarkOptionModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function SelectBenchmarkOptionModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function SelectBenchmarkOptionModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "p");
        i0.ɵɵtext(5, "Choose how Benchmark data appears across this report\u2019s modules.");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4)(7, "label", 5)(8, "input", 6);
        i0.ɵɵlistener("change", function SelectBenchmarkOptionModalComponent_Template_input_change_8_listener() { return ctx.selectOption(ctx.ShowBenchmarkOption.ALL); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "span", 7);
        i0.ɵɵelementStart(10, "span", 8)(11, "div");
        i0.ɵɵtext(12, "Show for all modules");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 9);
        i0.ɵɵtext(14, " Applies Benchmark to every module that supports it, for this generation only. ");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(15, "label", 5)(16, "input", 10);
        i0.ɵɵlistener("change", function SelectBenchmarkOptionModalComponent_Template_input_change_16_listener() { return ctx.selectOption(ctx.ShowBenchmarkOption.NONE); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(17, "span", 7);
        i0.ɵɵelementStart(18, "span", 8)(19, "div");
        i0.ɵɵtext(20, "Hide for all modules");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 9);
        i0.ɵɵtext(22, " Removes Benchmark from every module, for this generation only. ");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(23, "label", 5)(24, "input", 10);
        i0.ɵɵlistener("change", function SelectBenchmarkOptionModalComponent_Template_input_change_24_listener() { return ctx.selectOption(ctx.ShowBenchmarkOption.MODULE_DEFAULT); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(25, "span", 7);
        i0.ɵɵelementStart(26, "span", 8)(27, "div");
        i0.ɵɵtext(28, "Keep module settings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 9);
        i0.ɵɵtext(30, " Follows each module\u2019s own Benchmark selection from the report builder. ");
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelementStart(31, "div", 11)(32, "div", 12)(33, "div", 13);
        i0.ɵɵlistener("click", function SelectBenchmarkOptionModalComponent_Template_div_click_33_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵtext(34, "Cancel");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(35, "div", 14);
        i0.ɵɵconditionalCreate(36, SelectBenchmarkOptionModalComponent_Conditional_36_Template, 2, 0, "div", 15);
        i0.ɵɵelementStart(37, "div", 16);
        i0.ɵɵlistener("click", function SelectBenchmarkOptionModalComponent_Template_div_click_37_listener() { return ctx.forward(); });
        i0.ɵɵtext(38, "Next");
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("checked", ctx.showBenchmarkOption() === ctx.ShowBenchmarkOption.ALL);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("checked", ctx.showBenchmarkOption() === ctx.ShowBenchmarkOption.NONE);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("checked", ctx.showBenchmarkOption() === ctx.ShowBenchmarkOption.MODULE_DEFAULT);
        i0.ɵɵadvance(12);
        i0.ɵɵconditional(ctx.currentWizardStepIndex() != 0 ? 36 : -1);
    } }, dependencies: [i1.ModalBaseComponent, i2.SimpleModalHeaderComponent], encapsulation: 2 });
